import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <div className="relative z-10">
        <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 rounded-full bg-primary-100">
          <i className="ri-file-search-line text-4xl text-primary-500"></i>
        </div>
        <h1 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">页面走丢了</h1>
        <p className="text-sm text-foreground-500 max-w-md mx-auto">
          抱歉，您访问的页面不存在或已被移除。请回到首页浏览更多热门漫画。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-line"></i>
          返回99漫画首页
        </Link>
      </div>
    </div>
  );
}